<template>
  <div>
    <div :class="['digit', status]">{{ digit }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: "offline"
    }
  },
  computed: {
    digit() {
      const retVal = parseInt(this.value) > 0 ? parseInt(this.value) : 0;

      return retVal < 10
        ? "000" + retVal
        : retVal < 100
        ? "00" + retVal
        : retVal < 1000
        ? "0" + retVal
        : retVal;
    }
  }
};
</script>

<style>
@font-face {
  font-family: "Segment14";
  src: url("../assets/fonts/Segment14.otf") format("opentype");
}

.digit {
  font-family: "Segment14", sans-serif;
  font-weight: 300;
  font-size: 36px;
  display: inline-block;
  padding: 0 0 0 6px;
  line-height: 36px;
  border-radius: 3px;
}
.digit.success {
  background: #ebffed;
  color: #4caf50;
}
.digit.danger {
  background: #ffebeb;
  color: #af4c4c;
}
.digit.info {
  background: #ebf4ff;
  color: #4c7aaf;
}
</style>